var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',{staticClass:"text-h5 font-weight-bold mb-4"},[_vm._v("MRR Daily")]),_c('mrr-daily-panel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }